<pbc-filter-preset
  [filter]="felder.preset$ | async"
  [filters]="felder.presets$ | async"
  [name]="felder.search$ | async"
  (select)="felder.setFilter($event)"
  (save)="felder.writeFilter($event)"
  (delete)="felder.deleteFilter($event)"
></pbc-filter-preset>
